import RestApiModel from "@/api/Model/RestApiModel";
import api from '@/api';

class News extends RestApiModel {
  static getResourceEndpoint() {
    return '/content-management/news';
  }

  static getSalesCountries() {
    return api.get(`${this.getResourceEndpoint()}/sales-countries`);
  }

  /**
   * @param id
   * @param isEnabled
   * @returns {*}
   */
  static enable(id, isEnabled) {
    return api.patch(`${this.getResourceIdEndpoint(id)}/enable`, {isEnabled});
  }
}

export default News;
